import React, { useCallback } from 'react';
import { navigate } from 'gatsby';
import clsx from 'clsx';
import { Label } from 'components/UI/Elements/Label/label';
import {
  formatContentfulComponentProps,
  returnLocalisedPath,
} from 'utils/globals';
import { withLocale } from 'utils/hocs';
import { Link } from 'components/UI/Elements/Link';

export const BannerSwitcher = ({ bg, link }) => {
  return (
    <div
      className={clsx(
        'w-screen p-4 flex justify-center items-center space-x-2',
        {
          [`bg-${bg.classname}`]: !!bg?.classname,
        }
      )}>
      <Link {...link} />
    </div>
  );
};
